import { BackToCta } from "@faire/help-center-utils/components/BackToCta/BackToCta";
import { BackToDestination } from "@faire/help-center-utils/components/BackToCta/types";
import { Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterBackToClick } from "@faire/web-api--source/events/helpCenter/click/backTo";
import React from "react";
import styled from "styled-components";

import { useChatCsatStore } from "../hooks/ChatCsatContextStore";

export const ChatCsatCollected: React.FC = () => {
  const [{ surveyType }] = useChatCsatStore(["surveyType"]);
  return (
    <>
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          defaultMessage="Thanks for taking the time to share your feedback!"
          description={{
            text: "A title of the page that shows up after a user submits their feedback.",
          }}
        />
      </Typography>
      {surveyType !== "chat" ? (
        <>
          <Spacer height="3x" />
          <ButtonWrapper>
            <BackToCta
              destination={BackToDestination.HELP_CENTER}
              onClick={() => trackHelpCenterBackToClick("help_center")}
            />
            <Spacer width="2x" />
            <BackToCta
              variant="secondary"
              destination={BackToDestination.FAIRE}
              onClick={() => trackHelpCenterBackToClick("faire_home")}
            />
          </ButtonWrapper>
        </>
      ) : null}
    </>
  );
};

const ButtonWrapper = styled(Flex).attrs({
  justify: "space-between",
  direction: { tabletAndAbove: "row", mobileAndAbove: "column" },
})``;
